import React, { createContext, useContext } from 'react'

export interface GalleryContextValue {
  orgId: string
  storeId?: string
  getFolderId: (folderId: string) => string
  isFileImage: (file: unknown) => boolean
  compressImage?: (file: File, options: Record<string, unknown>) => Promise<File>
}

const GalleryContext = createContext<GalleryContextValue | undefined>(undefined)

export interface GalleryProviderProps {
  children: React.ReactNode
  value: GalleryContextValue
}

export const GalleryProvider: React.FC<GalleryProviderProps> = ({ children, value }) => {
  return <GalleryContext.Provider value={value}>{children}</GalleryContext.Provider>
}

export const useGalleryContext = () => {
  const context = useContext(GalleryContext)
  if (!context) {
    throw new Error('useGalleryContext must be used within GalleryProvider')
  }
  return context
}
